declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_teams_maps_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_teams_maps_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_maps['team_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__rows_shm_hitalama_teams_maps_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $shm_hitalama_teams_maps extends $shm_hitalama_map_catalog {
		team_add( next?: any ): any
		Add_team( ): $mol_button_minor
		team( ): $shm_hitalama_team
		param( ): string
		menu_title( ): string
		Add_map_menu( ): $mol_list
	}
	
}

//# sourceMappingURL=maps.view.tree.d.ts.map